export default /* glsl */`
  varying vec2 vUv;
  uniform sampler2D uTexture;
  uniform vec3 uTranslate;

  void main(){
    vec3 transformed = position;
    transformed += uTranslate;

    gl_Position = projectionMatrix * modelViewMatrix * vec4(transformed,1.);
    vUv = uv;
  }
`;
